import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useCallback, useState } from "react";
import { Desktop } from "./";
import { BootScreen } from "./components/BootScreen";
import demoConfig from "./desktop-config";
import { queryClient } from "./lib/queryClient";

const BOOT_STORAGE_KEY = "portfolio:boot-shown";

function shouldShowBoot(): boolean {
  if (new URLSearchParams(window.location.search).has("skipBoot")) return false;
  try {
    return !localStorage.getItem(BOOT_STORAGE_KEY);
  } catch {
    return true;
  }
}

function DesktopRoute() {
  const [showBoot] = useState(shouldShowBoot);
  const [booted, setBooted] = useState(!showBoot);
  const onBoot = useCallback(() => {
    setBooted(true);
    try {
      localStorage.setItem(BOOT_STORAGE_KEY, "1");
    } catch {
      // ignore
    }
  }, []);
  return (
    <>
      <Desktop config={demoConfig} booted={booted} />
      {showBoot && !booted && <BootScreen onComplete={onBoot} />}
    </>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<DesktopRoute />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
